/**
 * Gössl Tag-Scanner (r39b) — Etikett scannen statt tippen.
 * Fullscreen camera overlay that decodes the EAN-13 from a price tag and
 * hands it to GoesslTagLookup (PDP deep link / Filial-Stück card).
 * Decode engines: native BarcodeDetector where present (Android/Chrome),
 * else the self-hosted zxing-wasm reader (lazy-loaded, ~940 KB, iOS Safari).
 * Opens from [data-tag-scan] buttons; auto-opens on ?scan=1 (store-QR entry).
 */
(function () {
  'use strict';

  var overlay = null, video = null, stream = null, running = false;
  var engine = null; // 'native' | 'wasm'
  var detector = null, canvas = null, ctx = null, lastTick = 0;
  var btnCfg = null;

  function eanCheckOk(d) {
    var sum = 0;
    for (var i = 0; i < 12; i++) sum += Number(d[i]) * (i % 2 === 0 ? 1 : 3);
    return (10 - (sum % 10)) % 10 === Number(d[12]);
  }

  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'g26-scan';
    overlay.innerHTML =
      '<div class="g26-scan__stage">' +
      '<video class="g26-scan__video" playsinline muted autoplay></video>' +
      '<div class="g26-scan__frame" aria-hidden="true"></div>' +
      '<p class="g26-scan__hint">' + window.g26t('products.tag_scanner.hint', 'Richten Sie die Kamera auf den Strichcode des Etiketts') + '</p>' +
      '<p class="g26-scan__status" data-scan-status></p>' +
      '</div>' +
      '<div class="g26-scan__actions">' +
      '<button type="button" class="g26-scan__btn" data-scan-torch hidden>' + window.g26t('products.tag_scanner.torch', 'Licht') + '</button>' +
      '<button type="button" class="g26-scan__btn" data-scan-type>' + window.g26t('products.tag_scanner.type_number', 'Nummer eintippen') + '</button>' +
      '<button type="button" class="g26-scan__btn g26-scan__btn--close" data-scan-close aria-label="' + window.g26t('products.tag_scanner.close_label', 'Scanner schließen') + '">' + window.g26t('general.accessibility.close', 'Schließen') + '</button>' +
      '</div>';
    document.body.appendChild(overlay);
    video = overlay.querySelector('video');
    overlay.querySelector('[data-scan-close]').addEventListener('click', stop);
    overlay.querySelector('[data-scan-type]').addEventListener('click', function () {
      stop();
      var input = document.querySelector('#g26-search-input, input[name="q"]');
      if (input) { input.focus(); input.placeholder = window.g26tText('products.tag_scanner.type_placeholder', 'Nummer vom Etikett eintippen'); }
      else window.location.href = window.g26url('search');
    });
    overlay.querySelector('[data-scan-torch]').addEventListener('click', toggleTorch);
  }

  function status(msg) {
    var el = overlay && overlay.querySelector('[data-scan-status]');
    if (el) el.textContent = msg || '';
  }

  var torchOn = false;
  function toggleTorch() {
    if (!stream) return;
    var track = stream.getVideoTracks()[0];
    if (!track) return;
    torchOn = !torchOn;
    track.applyConstraints({ advanced: [{ torch: torchOn }] }).catch(function () {});
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function initEngine() {
    if ('BarcodeDetector' in window) {
      return window.BarcodeDetector.getSupportedFormats().then(function (formats) {
        if (formats.indexOf('ean_13') !== -1) {
          detector = new window.BarcodeDetector({ formats: ['ean_13'] });
          engine = 'native';
          return;
        }
        return initWasm();
      }).catch(initWasm);
    }
    return initWasm();
  }

  function initWasm() {
    if (window.ZXingWASM) { engine = 'wasm'; return Promise.resolve(); }
    if (!btnCfg || !btnCfg.js || !btnCfg.wasm) return Promise.reject(new Error('no zxing cfg'));
    status(window.g26t('products.tag_scanner.loading', 'Scanner wird geladen …'));
    return loadScript(btnCfg.js).then(function () {
      window.ZXingWASM.prepareZXingModule({
        overrides: { locateFile: function () { return btnCfg.wasm; } },
        fireImmediately: true,
      });
      engine = 'wasm';
      canvas = document.createElement('canvas');
      ctx = canvas.getContext('2d', { willReadFrequently: true });
      status('');
    });
  }

  function onHit(text) {
    if (!/^\d{13}$/.test(text) || !eanCheckOk(text)) return false;
    running = false;
    if (navigator.vibrate) navigator.vibrate(60);
    status(window.g26t('products.tag_scanner.found', 'Gefunden – einen Moment …'));
    window.GoesslTagLookup.lookup(text, 'scan').then(function (data) {
      status('');
      showResult(data, text);
    });
    return true;
  }

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    var f = n.toFixed(2).split('.');
    return f[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + f[1] + ' €';
  }

  // r39f (SJ): a scan doesn't navigate away — it shows the piece with
  // "Zur Merkliste", so customers can walk the rail and collect favourites
  // tag by tag. Store mode makes each saved piece remember its Gwandhaus.
  function showResult(data, q) {
    var old = overlay.querySelector('.g26-scan__result');
    if (old) old.remove();
    var sheet = document.createElement('div');
    sheet.className = 'g26-scan__result';

    var resume = function () {
      sheet.remove();
      running = true;
      requestAnimationFrame(tick);
    };

    var addBtnRow = function (row) {
      var again = document.createElement('button');
      again.type = 'button';
      again.className = 'g26-scan__result-link';
      again.textContent = window.g26tText('products.tag_scanner.scan_again', 'Weiter scannen');
      again.addEventListener('click', resume);
      row.appendChild(again);
    };

    if (!data || data.type === 'none') {
      var miss = document.createElement('p');
      miss.className = 'g26-scan__result-note';
      miss.textContent = window.g26tText('products.tag_lookup.not_found_plain', 'Zur Nummer {{ number }} haben wir leider nichts gefunden.', { number: q });
      sheet.appendChild(miss);
      var mrow = document.createElement('div');
      mrow.className = 'g26-scan__result-actions';
      addBtnRow(mrow);
      sheet.appendChild(mrow);
      overlay.querySelector('.g26-scan__stage').appendChild(sheet);
      return;
    }

    var body = document.createElement('div');
    body.className = 'g26-scan__result-body';
    if (data.image) {
      var img = document.createElement('img');
      img.src = data.image;
      img.alt = data.title || '';
      img.className = 'g26-scan__result-img';
      body.appendChild(img);
    }
    var info = document.createElement('div');
    info.className = 'g26-scan__result-info';
    var title = document.createElement('p');
    title.className = 'g26-scan__result-title';
    title.textContent = data.title || '';
    info.appendChild(title);
    var priceLine = data.price ? money(data.price) : (data.priceMin ? money(data.priceMin) : '');
    if (priceLine) {
      var price = document.createElement('p');
      price.className = 'g26-scan__result-price';
      price.textContent = priceLine;
      info.appendChild(price);
    }
    if (data.type === 'pos_only') {
      var note = document.createElement('p');
      note.className = 'g26-scan__result-note';
      note.textContent = window.g26tText('products.tag_lookup.stores_only', 'Dieses Modell führen wir derzeit nur in unseren Geschäften.');
      info.appendChild(note);
    }
    body.appendChild(info);
    sheet.appendChild(body);

    var row = document.createElement('div');
    row.className = 'g26-scan__result-actions';

    var handle = data.handle || (data.url ? String(data.url).split('?')[0].split('/products/')[1] : null);
    if (data.type === 'online' && handle && window.Goessl && window.Goessl.wishlist) {
      var wish = document.createElement('button');
      wish.type = 'button';
      wish.className = 'g26-scan__result-cta';
      var wished = window.Goessl.wishlist.hasItem(handle);
      wish.textContent = wished ? window.g26tText('wishlist.saved_check', 'Gemerkt ✓') : window.g26tText('wishlist.to_wishlist', 'Zur Merkliste');
      if (wished) wish.disabled = true;
      wish.addEventListener('click', function () {
        window.Goessl.wishlist.addItem(handle);
        // A guest tap opens the sign-in prompt instead of adding — only
        // confirm when the piece actually landed on the list.
        if (window.Goessl.wishlist.hasItem(handle)) {
          if (window.Goessl.wishlist.updateUI) window.Goessl.wishlist.updateUI();
          wish.textContent = window.g26tText('wishlist.saved_check', 'Gemerkt ✓');
          wish.disabled = true;
        }
      });
      row.appendChild(wish);
    }
    var detail = document.createElement('a');
    detail.className = 'g26-scan__result-link';
    if (data.type === 'online' && data.url) {
      detail.href = (/^https?:\/\//i.test(data.url) ? data.url : window.g26url(data.url));
      detail.textContent = window.g26tText('blogs.article.to_product', 'Zum Produkt');
    } else {
      detail.href = window.g26url('search') + '?q=' + encodeURIComponent(q);
      detail.textContent = window.g26tText('products.tag_scanner.view_availability', 'Verfügbarkeit ansehen');
    }
    row.appendChild(detail);
    addBtnRow(row);
    sheet.appendChild(row);
    overlay.querySelector('.g26-scan__stage').appendChild(sheet);
  }

  function tick(ts) {
    if (!running) return;
    if (ts - lastTick < 180) { requestAnimationFrame(tick); return; }
    lastTick = ts;
    if (!video || video.readyState < 2) { requestAnimationFrame(tick); return; }
    if (engine === 'native') {
      detector.detect(video).then(function (codes) {
        for (var i = 0; i < codes.length; i++) if (onHit(codes[i].rawValue)) return;
        requestAnimationFrame(tick);
      }).catch(function () { requestAnimationFrame(tick); });
    } else {
      var w = Math.min(video.videoWidth, 1280);
      var h = Math.round(video.videoHeight * (w / video.videoWidth));
      canvas.width = w; canvas.height = h;
      ctx.drawImage(video, 0, 0, w, h);
      var img = ctx.getImageData(0, 0, w, h);
      window.ZXingWASM.readBarcodes(img, { formats: ['EAN-13'], maxNumberOfSymbols: 1 }).then(function (res) {
        for (var i = 0; i < res.length; i++) if (res[i].isValid && onHit(res[i].text)) return;
        requestAnimationFrame(tick);
      }).catch(function () { requestAnimationFrame(tick); });
    }
  }

  function start(cfg) {
    btnCfg = cfg || btnCfg;
    if (!overlay) buildOverlay();
    // In store mode, the deliberate scan gesture is the one moment we also
    // confirm the store via device location (on-device only, see store-mode.js).
    if (window.GoesslStoreMode && window.GoesslStoreMode.geoCheck) window.GoesslStoreMode.geoCheck();
    overlay.classList.add('is-open');
    document.body.classList.add('scan-open');
    status('');
    initEngine().then(function () {
      return navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment', width: { ideal: 1920 }, height: { ideal: 1080 } },
        audio: false,
      });
    }).then(function (s) {
      stream = s;
      video.srcObject = s;
      var track = s.getVideoTracks()[0];
      try {
        var caps = track.getCapabilities ? track.getCapabilities() : {};
        if (caps.torch) overlay.querySelector('[data-scan-torch]').hidden = false;
      } catch (e) {}
      return video.play();
    }).then(function () {
      running = true;
      requestAnimationFrame(tick);
    }).catch(function (err) {
      var denied = err && (err.name === 'NotAllowedError' || err.name === 'SecurityError');
      status(denied
        ? window.g26tText('products.tag_scanner.camera_denied', 'Kamerazugriff wurde nicht erlaubt – Sie können die Nummer vom Etikett auch eintippen.')
        : window.g26tText('products.tag_scanner.camera_unavailable', 'Die Kamera steht gerade nicht zur Verfügung – tippen Sie die Nummer vom Etikett einfach ein.'));
    });
  }

  function stop() {
    running = false;
    if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); stream = null; }
    if (video) video.srcObject = null;
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('scan-open');
    torchOn = false;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) stop();
  });

  function cfgFrom(btn) {
    return { js: btn.getAttribute('data-zxing-js'), wasm: btn.getAttribute('data-zxing-wasm') };
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tag-scan]');
    if (!btn) return;
    e.preventDefault();
    start(cfgFrom(btn));
  });

  // Store-QR entry: /search?scan=1 opens the scanner straight away.
  function autoOpen() {
    if (new URLSearchParams(window.location.search).get('scan') !== '1') return;
    var btn = document.querySelector('[data-tag-scan]');
    if (btn) start(cfgFrom(btn));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoOpen);
  else autoOpen();

  window.GoesslTagScanner = { start: start, stop: stop };
})();
